import React from 'react';
import { addReactError } from '@datadog/browser-rum-react';

import App from 'app';
import { initializeDatadogRum } from 'shared/lib/datadog.rum';
import reportWebVitals from './reportWebVitals';
import { createRoot } from 'react-dom/client';

/**
 * @author Kirill Chernopyatov
 * @description The project uses the Headlessui package.
 * We use the Dialog component for our component Modal.
 * In one of the updates of Headlessui, a feature appeared that sets for HTMLElement nodes the property - inert, when leafes are open.
 * Inert blocks interactivity for node.
 * This function mutates our node with ID - ROOT, and does not allow it to install inert.
 */
const getRendererNode = () => {
  const node = document.getElementById('root');
  Object.defineProperty(node, 'inert', {
    get() {
      return false;
    },
    set() {},
    enumerable: false,
    configurable: false,
  });
  return node;
};

const datadogRumInitialized = initializeDatadogRum();

const root = createRoot(
  getRendererNode() as HTMLElement,
  datadogRumInitialized
    ? {
        onUncaughtError: (error, errorInfo) => {
          addReactError(error, errorInfo);
          console.error('Uncaught React error:', error, errorInfo);
        },
        onCaughtError: (error, errorInfo) => {
          addReactError(error, errorInfo);
          console.error('Caught React error:', error, errorInfo);
        },
        onRecoverableError: (error, errorInfo) => {
          addReactError(error, errorInfo);
          console.warn('Recoverable React error:', error, errorInfo);
        },
      }
    : undefined
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// ReactDOM.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
//   getRendererNode()
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
